// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';


class EditFixture extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      fixture: {
        "name": "",
        "venue": "",
        "game_type": 1,
        "age_group_id": '',
        "game_level_id": 1,
        "day_of_week": 0,
        "start_time": "19:30:00",
        "end_time": "20:15:00",
        "max_subscribers": 30,
        "batch_size": 14,
        "home_batch_vote_start_duration": "1 00:00:00",
        "flexi_batch_vote_start_duration": "04:00:00",
        "cut_off_duration": "01:00:00",
        "price": 200.0
      },
      data_uploaded: false,
      data_error: false,
      venues: [],
      game_types: [],
      game_levels: [],
      age_groups: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }


  componentDidMount() {
    this.getFixtureList();
  }

  getFixtureList() {
     const url = `${getLocationOrigin()}/eagleeye/${this.state.id}/get_details_for_edit_fixture/`;
     const options = {...defaultOptions};

     fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ venues: data.venues, game_types: data.game_type, fixture: data.fixture, game_levels: data.game_levels, age_groups: data.age_groups }))
       .catch(error => error);
  }

  postEditedFixture(data, props) {
    const url = `${getLocationOrigin()}/eagleeye/edit_fixture/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({'fixture': data});
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){                      // first then()
          alert(response.message);
      })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }

  dayOfWeek() {
    return [
      {id:0, name: 'Monday'},
      {id:1, name: 'Tuesday'},
      {id:2, name: 'Wednesday'},
      {id:3, name: 'Thursday'},
      {id:4, name: 'Friday'},
      {id:5, name: 'Saturday'},
      {id:6, name: 'Sunday'},
    ]
  }

  handleChange(event) {
    const name = event.target.name;
    var new_selected_one = Object.assign({}, this.state.fixture);
    new_selected_one[name] = event.target.value
    console.log('asdddddddddd');
    console.log(new_selected_one);
    this.setState({fixture: new_selected_one});
  }

  handleSubmit(event) {
    event.preventDefault();
    console.log('Submit');
    console.log(this.state.fixture);
    this.postEditedFixture(this.state.fixture, this.props);
    console.log('post');
    console.log(this.state);
  }

  render() {
    return(
      <div style={styles.container}>
        <div className="row col-md-8 table-bordered" style={styles.table}>
          <div style={styles.main_header} className="col-md-12">
            <h3 style={{textAlign:'center'}}>Edit Fixture</h3>
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Batch Name
              </div>
              <input type="text"
                style={styles.input}
                name="name"
                value={this.state.fixture.name}
                onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Venue
              </div>
              <select name="venue" className="col-md-6" style={styles.item_body} value={this.state.fixture.venue}
                onChange={this.handleChange}>
                {
                  this.state.venues.map((x, index) => (
                  <option key={x.id} value={x.id}>{x.name}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Day of week
              </div>
              <select name="day_of_week" style={styles.item_body} className="col-md-6"
                value={this.state.fixture.day_of_week} onChange={this.handleChange}>
                {
                  this.dayOfWeek().map((x, index) => (
                  <option key={x.id} value={x.id}>{x.name}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Game type
              </div>
              <select name="game_type" style={styles.item_body} className="col-md-6"
                value={this.state.fixture.game_type} onChange={this.handleChange}>
                {
                  this.state.game_types.map((x, index) => (
                  <option key={x.pk} value={x.pk}>{x.game + ' ' + x.name}</option>
                  ))
                }
              </select>
            </div>
             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Game Levels
              </div>
              <select name="game_level_id" style={styles.item_body} className="col-md-6"
                value={this.state.fixture.game_level_id} onChange={this.handleChange}>
                {
                  this.state.game_levels.map((x, index) => (
                  <option key={x.pk} value={x.pk}>{x.game.name + ' ' + x.name}</option>
                  ))
                }
              </select>
            </div>
             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Age Group
              </div>
              <select name="age_group_id" style={styles.item_body} className="col-md-6" value={this.state.fixture.age_group_id} onChange={this.handleChange}>
                {
                  this.state.age_groups.map((x, index) => (
                  <option key={x.id} value={x.id}>{x.abbreviation}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Start Time
              </div>
              <input type="text" style={styles.input} className="required" name="start_time" value={this.state.fixture.start_time}
                onChange={this.handleChange} placeholder="19:30:00"/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                End Time
              </div>
              <input type="text" style={styles.input} name="end_time" className="required" value={this.state.fixture.end_time}
                onChange={this.handleChange} placeholder="20:30:00"/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Max Subscribers
              </div>
              <input type="text" style={styles.input} name="max_subscribers" className="required"
                value={this.state.fixture.max_subscribers} onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Max Vote In
              </div>
              <input type="text" style={styles.input} name="batch_size" className="required"
                value={this.state.fixture.batch_size} onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Per Session Price
              </div>
              <input type="text" style={styles.input} name="price" className="required"
                value={this.state.fixture.price} onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Home batch Vote In Start
              </div>
              <input type="text" style={styles.input} name="home_batch_vote_start_duration" className="required"
                value={this.state.fixture.home_batch_vote_start_duration} onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Flexi Start
              </div>
              <input type="text" style={styles.input} name="flexi_batch_vote_start_duration" className="required"
                value={this.state.fixture.flexi_batch_vote_start_duration} onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Cut Off Duration
              </div>
              <input type="text" style={styles.input} name="cut_off_duration" className="required"
                value={this.state.fixture.cut_off_duration} onChange={this.handleChange}/>
            </div>

            <div style={styles.button_submit} className="col-md-12">
              <input className="btn btn-lg" type="submit" value="Submit" style={{backgroundColor:'#302C35',
                color:'#ffffff'}}/>
            </div>
            <div className="col-md-12">
              {this.state.data_uploaded?<div className="text-success" style={styles.success}>* Fixture created successfully.</div>:''}
              {this.state.data_error?<div className="text-danger" style={styles.success}>* Error, creation failed.</div>:''}
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default EditFixture;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/editFixture/index.js